<template>
  <div
    id="loading-items__scroll-loading"
    class="scroll-loading" 
    v-if="loadingInternal"
  >
    <v-progress-circular indeterminate :size="24" :width="6" color="#ff7a00" />
    <span>Carregando mais veículos</span>
  </div>

  <div 
    id="loading-items__scroll-finalizado"
    class="scroll-loading" 
    v-else-if="!loading && selectedPage >= totalPages && totalPages > 0"
  >
    <p>
      Parece que você explorou todas nossas ofertas. Não encontrou o que procurava? <br />
      A cada dia, novos carros.
      <a href="#" @click.prevent="openModal" style="margin-right: 7px;">Crie um alerta</a> e seja o primeiro a saber.
    </p>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  props: {
    loading: Boolean,
    selectedPage: Number,
    totalPages: Number
  },
  data() {
    return {
      loadingInternal: this.loading,
      delayTimeout: null
    };
  },
  computed: {
    ...mapState("followCarModalModule", ["modalIsOpen"]),
  },
  methods: {
    ...mapActions("followCarModalModule", ["getAlertList"]),
    ...mapMutations("followCarModalModule", ["toggleModal"]),
    openModal() {
      this.toggleModal();
      if (this.modalIsOpen) {
        this.getAlertList();
      }
    }
  },
  watch: {
    loading(newVal) {
      if (newVal) {
        this.loadingInternal = true;
        clearTimeout(this.delayTimeout);
        this.delayTimeout = setTimeout(() => {
          this.loadingInternal = false;
        }, 3000);
      } else {
        clearTimeout(this.delayTimeout);
        this.loadingInternal = false;
      }
    }
  },
  beforeUnmount() {
    clearTimeout(this.delayTimeout);
  }
};
</script>

<style scoped>
.scroll-loading {
  margin-top: 30px;
  margin-bottom: 100px;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  padding: 20px;
  flex-direction: column;
  text-align: center;
}

.scroll-loading span {
  font-family: "Lexend Deca";
  font-size: 20px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
}

.scroll-loading p {
  font-family: "Lexend Deca";
  font-size: clamp(14px, 1.5vw, 16px) !important;
  font-weight: bold;
  text-align: center;
}

@media only screen and (max-width: 920px) {
  .scroll-loading p {
    padding: 0;
  }

  .scroll-loading span {
    font-size: 16px;
  }
}

.scroll-loading p a {
  color: #ff7a00;
}
</style>